import Phaser from 'phaser';

import { getLaneShapePoints } from './laneShape';

import type { LaneShapeMetrics } from './laneShape';

type DrawLaneOptions = {
	graphics: Phaser.GameObjects.Graphics;
	metrics: LaneShapeMetrics;
	laneLinesCount: number;
	bottomLineWidth: number;
	laneColor: number;
	laneLineColor: number;
};

export function drawLane({
	graphics,
	metrics,
	laneLinesCount,
	bottomLineWidth,
	laneColor,
	laneLineColor,
}: DrawLaneOptions) {
	graphics.clear();
	graphics.fillStyle(laneColor, 1);
	graphics.fillPoints(getLaneShapePoints(metrics), true);
	graphics.fillStyle(laneLineColor, 1);

	if (laneLinesCount <= 1) {
		return;
	}

	const topHalfWidth = 1.5;
	const bottomHalfWidth = bottomLineWidth / 2;

	for (let lineIndex = 1; lineIndex <= laneLinesCount - 1; lineIndex += 1) {
		const fraction = lineIndex / laneLinesCount;
		const topX = metrics.centerX + (fraction - 0.5) * metrics.topWidthPx;
		const bottomX = metrics.centerX + (fraction - 0.5) * metrics.bottomWidthPx;

		graphics.fillPoints(
			[
				new Phaser.Geom.Point(topX - topHalfWidth, metrics.topOffset),
				new Phaser.Geom.Point(topX + topHalfWidth, metrics.topOffset),
				new Phaser.Geom.Point(bottomX + bottomHalfWidth, metrics.topOffset + metrics.height),
				new Phaser.Geom.Point(bottomX - bottomHalfWidth, metrics.topOffset + metrics.height),
			],
			true,
		);
	}
}
